import { render, staticRenderFns } from "./author_dialog.vue?vue&type=template&id=2535af44&"
import script from "./author_dialog.vue?vue&type=script&lang=js&"
export * from "./author_dialog.vue?vue&type=script&lang=js&"
import style0 from "./author_dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports